//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum FileCrossAttributes {
	NoAttribute = 0,
	DefaultImage = 1,
	TechnicalDocument = 2
}
